import React, { useMemo, useState } from 'react';
import { Select, Space, Typography } from 'antd';
import { useFilterStore } from '../../store/useFilters';
import { Ambassador } from '../../types';

const { Text } = Typography;
const { Option } = Select;

interface CountryFilterProps {
  ambassadors: Ambassador[];
}

const CountryFilter: React.FC<CountryFilterProps> = ({ ambassadors }) => {
  const { filters, setCountryFilter } = useFilterStore();
  const [searchValue, setSearchValue] = useState('');

  // Get unique countries with counts
  const countryData = useMemo(() => {
    const countryCounts = ambassadors.reduce((acc, ambassador) => {
      const country = ambassador.country;
      if (country) {
        acc[country] = (acc[country] || 0) + 1;
      }
      return acc;
    }, {} as Record<string, number>);

    return Object.entries(countryCounts)
      .map(([country, count]) => ({ country, count }))
      .sort((a, b) => b.count - a.count);
  }, [ambassadors]);

  const handleCountryChange = (selectedCountries: string[]) => {
    setCountryFilter(selectedCountries);
  };

  return (
    <div style={{ width: '100%' }}>
      <Select
        mode="multiple"
        placeholder="Select countries..."
        value={filters.countries}
        onChange={handleCountryChange}
        style={{ width: '100%' }}
        size="small"
        maxTagCount={2}
        showSearch
        filterOption={(input, option) =>
          (option?.children as string)?.toLowerCase().includes(input.toLowerCase())
        }
      >
        {countryData.map(({ country, count }) => (
          <Option key={country} value={country}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '12px' }}>{country}</span>
              <span 
                style={{
                  fontSize: '10px',
                  color: '#999',
                  backgroundColor: '#f5f5f5',
                  padding: '1px 4px',
                  borderRadius: '6px',
                  marginLeft: '8px',
                }}
              >
                {count}
              </span>
            </div>
          </Option>
        ))}
      </Select>
      
      {filters.countries.length > 0 && (
        <div style={{ marginTop: '8px', fontSize: '11px', color: '#666' }}>
          <Text type="secondary">
            {filters.countries.length} country{filters.countries.length > 1 ? 's' : ''} selected
          </Text>
        </div>
      )}
    </div>
  );
};

export default CountryFilter;